//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "common",
  methods: {
    updateChart: function updateChart() {
      var optionData = this.deepClone(this.dataChart) || [];
      var option = this.echartFormatter && this.echartFormatter(optionData);
      this.myChart.resize();
      this.myChart.setOption(option, true);
    }
  }
});